module.exports = __webpack_public_path__ + "img/logo_simple.516e61f4.png";